export * from 'fs';
export { default } from 'fs';